/**
* default prefix "TYPE_SWITCHER"
**/
export const AT_TYPE_SWITCHER_BOARD_TYPE_SET = 'TYPE_SWITCHER_BOARD_TYPE_SET';
export const AT_TYPE_SWITCHER_LAST_KANBAN_VIEW_SET = 'TYPE_SWITCHER_LAST_KANBAN_VIEW_SET';
